import {
  SET_GLOBAL_START_DATE,
  SET_GLOBAL_END_DATE,
  RESET_GLOBAL_START_DATE,
  RESET_GLOBAL_END_DATE,
} from './types/GlobalPeriodSelectionTypes';

export function setGlobalStartDateSelectionActionCreator(startDate) {
  return {
    type: SET_GLOBAL_START_DATE,
    payload: {
      globalStartDate: startDate,
    },
  };
}

export function setGlobalEndDateSelectionActionCreator(endDate) {
  return {
    type: SET_GLOBAL_END_DATE,
    payload: {
      globalEndDate: endDate,
    },
  };
}

export function resetGlobalStartDateSelectionActionCreator() {
  return {
    type: RESET_GLOBAL_START_DATE,
    payload: {
      globalStartDate: null,
    },
  };
}

export function resetGlobalEndDateSelectionActionCreator() {
  return {
    type: RESET_GLOBAL_END_DATE,
    payload: {
      globalEndDate: null,
    },
  };
}
